/**
 * Nos ayudará a generar una lista de nombre
 */

const getImagesNamesGroup = (images_list: any) => {
    let image_list_end = images_list.reduce((prev: any, current: any) => {
        const current_name: string = current.name.split('_')[0];
        if (!(prev as Array<string>).includes(current_name)) {
            prev.push(current.name.split('_')[0]);
        }
        return prev;
    }, []);
    return image_list_end;
};

export default getImagesNamesGroup;
